import r from "./index.es262.js";
import t from "./index.es263.js";
function m(e) {
  return r(t(e), {
    attribute: !1
  });
}
export {
  m as default
};
//# sourceMappingURL=index.es243.js.map
